import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';

class UserList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      users: [],
      authUser: JSON.parse(localStorage.getItem('authUser'))
    };
  }

  componentDidMount() {
    this.setState({ loading: true });

    this.props.firebase.users().on('value', snapshot => {
      const usersObject = snapshot;
      let usersList = [];
      usersObject.forEach((user) => {
        if(user.val().roles === undefined) {
          usersList.push( { uid: user.key, ...user.val() });
        }
      });
     

      this.setState({
        users: usersList,
        loading: false,
      });
    });
  }

  componentWillUnmount() {
    this.props.firebase.users().off();
  }

  render() {
    const { users, loading } = this.state;

    return (
      <div>
         <div className="row">
            <div className="col-md-12" style={{ textAlign: 'center' }} >
              <h1>Welcome, Admin {this.state.authUser.username}</h1>
            </div>
        </div>
        <h2>Instructors</h2>
        <Link
            to={{
              pathname: `${ROUTES.CREATE_USER}`,
            }}
          >
            Create new instructor
         </Link>
        {loading && <div>Loading ...</div>}
        <ul>
          {users.map(user => (
            <li key={user.uid}>
             
              <span>
                <Link
                  to={{
                    pathname: `${ROUTES.USERS}/${user.uid}/edit`,
                    state: { user },
                  }}
                >
                  {user.name} {user.username}
                </Link>
              </span>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default withFirebase(UserList);
